// extracted by mini-css-extract-plugin
export default {"trackingSection":"styles_trackingSection__24zCW","trackingSectionTop":"styles_trackingSectionTop__zC33z","headingFlex":"styles_headingFlex__JtDbO"};